import React from 'react';
import PropTypes from 'prop-types';
import TidalLogo from '../../../../assets/images/promos/tidal/tidal-logo-white.svg';
import CloseButton from '../../../../assets/images/promos/tidal/tidal-close.svg';

const PromoModalTidal = ({ closeModal, reserveAndPayButton, handleReserve, customReserveButton, showPromo }) => (
  <div className="c-promo-modal-tidal">
    <div className="c-promo-modal_tidal_flag">2 Free Months</div>
    <button className="c-promo-modal_close" onClick={closeModal}><img src={CloseButton} alt="Close Modal" /></button>
    <img className="c-promo-modal_logo" src={TidalLogo} alt="TIDAL" />
    <p>
      Are you sure you want to proceed without&nbsp;
      <b>2 free months of music streaming with TIDAL?</b>
    </p>
    {reserveAndPayButton}
    {customReserveButton}
    {!customReserveButton &&
      <button className="c-btn c-btn--secondary" onClick={handleReserve} showPromo={showPromo}>
        I just want to reserve
      </button>
    }
  </div>
);

PromoModalTidal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  reserveAndPayButton: PropTypes.func.isRequired,
  handleReserve: PropTypes.func.isRequired,
  customReserveButton: PropTypes.func,
  showPromo: PropTypes.bool,
};

PromoModalTidal.defaultProps = {
  customReserveButton: null,
  showPromo: false,
};

export default PromoModalTidal;



// WEBPACK FOOTER //
// ./src/app/reservation/components/PromoModalTidal.jsx